import tmhRequest from '@/config/tmhRequest'

export default {
    searchMemberClassifyReportCount: function (data) {
        return tmhRequest({
            url: '/report/tmh/memberclassifyreport/searchmemberclassifyreportcount',
            method: 'post',
            data: data,
        })
    },
    searchMemberClassifyReportByPage: function (data) {
        return tmhRequest({
            url: '/report/tmh/memberclassifyreport/searchmemberclassifyreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportMemberClassifyReport: function (data) {
        return tmhRequest({
            url: '/report/tmh/memberclassifyreport/exportmemberclassifyreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/report/memberclassifyreport.js